import React from 'react';
import axios from 'axios';
import { toast } from 'bulma-toast';
import server from '../../../../utilities/server';

const CategoryTheme = ({ modal, setModal, refetch, category }) => {

  const [theme, setTheme] = React.useState(null);
  const [themeData, setThemeData] = React.useState(null);
  const [loading, setLoading] = React.useState(false);

  const _selectTheme = (theme) => {
    setTheme(theme.target.files[0]);
  }
  const _deselectTheme = () => {
    setTheme(null);
  }

  const ShowTheme = () => {
    if (!themeData) { return null; }
    return (
      <div id='theme' className='has-text-centered p-3'>
        <a className='delete' aria-label='close' onClick={_deselectTheme}></a>
        <img src={themeData} style={{ maxWidth: 150, maxHeight: 150, }} /><br />
        {
          category.theme && typeof category.theme === 'string' ? <a className='button is-danger' onClick={_deleteTheme} style={loading ? { PointerEvent: 'none' } : null}>حذف القالب</a> : null
        }
      </div>
    )
  }

  const _deleteTheme = async () => {
    setLoading(true);
    try {
      await axios.delete(`http://localhost:3003/admin/media/category-them/${category.id}`, { params: { name: category.theme, } });
      toast({ type: 'is-success', position: 'center', message: 'تم حذف القالب بنجاح', });
      setThemeData(null);
      setLoading(false);
    } catch (_) {
      setLoading(false);
      toast({ type: 'is-danger', position: 'center', message: 'خطأ أثناء حذف القالب', });
    }
  }

  const _getTheme = async () => {
    if (category.theme) {
    const theme = await axios.get('http://localhost:3003/admin/media/category-image', { params: { name: category.theme, }, responseType: 'blob', });
    setThemeData(URL.createObjectURL(theme.data));
    } else {
      setThemeData(null);
    }
  }

  const _submit = async () => {
    setLoading(true);
    const formData = new FormData();
    formData.append('theme', theme);
    formData.append('resize', true);
    server({
      method: 'put',
      path: `categories/theme/${category.id}`,
      data: formData,
    }).then((updateCategory) => {
      console.log(updateCategory)
      toast({ type: 'is-success', position: 'center', message: 'تم رفع القالب بنجاح' });
      refetch();
      setModal({ id: 0, name: null });
      setTheme(null);
      setLoading(false);
    }).catch((_) => {
      console.log(_.response)
      toast({ type: 'is-danger', position: 'center', message: 'خطأ أثناء رفع القالب' });
      setModal({ id: 0, name: null });
      setLoading(false);
    });
  }

  React.useEffect(() => {
    _getTheme();
    if (theme && typeof theme === 'object') {
      let reader = new FileReader();
      reader.onload = (data) => setThemeData(data.target.result);
      reader.readAsDataURL(theme);
    }
  }, [theme, modal]);

  return (
    <div className={`modal ${modal ? 'is-active' : ''}`}>
      <div className='modal-background' onClick={() => setModal({ id: 0, name: null })}></div>
      <div className='modal-card'>
        <header className='modal-card-head'>
          <p className='modal-card-title'>قالب القسم {category.name}</p>
          <a className='delete' aria-label='close' onClick={() => setModal({ id: 0, name: null })}></a>
        </header>
        <div className='modal-card-body'>
          <div className='file is-boxed is-centered'>
            <label className='file-label'>
              <input className='file-input' type='file' name='theme' onChange={ _selectTheme } />
              <span className='file-cta'>
                <span className='file-label'>
                  اختر القالب
                </span>
              </span>
            </label>
          </div>
          <ShowTheme />
        </div>
        <footer className='modal-card-foot'>
          <a type='button' className='button' data-bs-dismiss='modal' onClick={() => setModal({ id: 0, name: null })}>اغلاق</a>
          <button type='submit' className='button is-danger' onClick={ _submit } disabled={loading}>حفظ</button>
        </footer>
      </div>
    </div>
  )
}

export default CategoryTheme;
